(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["loyalty"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.custom-accordian').forEach((accordian) => {
    accordian.querySelectorAll('.acoordion-item').forEach((item) => {
      const title = item.querySelector('.acoordion-item-title');
      const body = item.querySelector('.acoordion-item-body');

      body.style.maxHeight = '0px';
      body.style.overflow = 'hidden';
      body.style.transition = 'max-height 0.3s ease';

      title.addEventListener('click', () => {
        item.classList.toggle('active');

        if (item.classList.contains('active')) {
          body.style.maxHeight = body.scrollHeight + 'px';
        } else {
          body.style.maxHeight = '0px';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
